export default "__VITE_ASSET__f4a1b182__"